import { useContext } from "react";
import { MdArrowOutward } from "react-icons/md";
import { AppContext } from "../App";
import { MotionGroup, MotionItem, MotionReveal, MotionText } from "../components/MotionReveal";
import { projects } from "./ProjectsContent";

export default function HomeProjectSection() {
  const appContext = useContext(AppContext);
  const featuredProjects = projects.slice(0, 3);

  function goToProject(slug) {
    appContext.navTo({ item: "projects", subItem: slug });
  }

  return (
    <section className="tgm-section tgm-home-projects">
      <div className="container">
        <MotionGroup
          className="tgm-editorial-head tgm-editorial-head-dark"
          stagger={0.08}
        >
          <div>
            <MotionReveal
              as="p"
              className="tgm-editorial-kicker"
              variant="soft"
            >
              Recent Work
            </MotionReveal>
            <MotionText as="h2" text="Take A Look At Our Latest Projects" />
          </div>
          <MotionReveal
            as="button"
            type="button"
            className="tgm-view-more-btn tgm-view-more-btn-dark"
            onClick={() => appContext.navTo({ item: "projects" })}
            variant="right"
            whileHover={{ x: 4 }}
            whileTap={{ scale: 0.96 }}
          >
            View more <MdArrowOutward />
          </MotionReveal>
        </MotionGroup>

        <MotionGroup className="tgm-home-project-grid" stagger={0.1}>
          {featuredProjects.map((project, index) => (
            <MotionItem
              as="article"
              variant="card"
              className="tgm-home-project-card"
              key={project.slug}
              role="button"
              tabIndex="0"
              onClick={() => goToProject(project.slug)}
              onKeyDown={(event) => {
                if (event.key === "Enter") {
                  goToProject(project.slug);
                }
              }}
              whileHover={{ y: -8 }}
              whileTap={{ scale: 0.985 }}
            >
              <div className="tgm-home-project-image">
                <img src={project.image} alt={project.name} />
              </div>
              <h3>{project.name}</h3>
              <p>{project.description}</p>
              <span className="tgm-home-project-link">
                Get A Quote <MdArrowOutward />
              </span>
            </MotionItem>
          ))}
        </MotionGroup>
      </div>
    </section>
  );
}
